module.exports = __webpack_public_path__ + "static/media/bunny-lesb.d7ef0998.jpg";